import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Collapse, useTheme } from "@mui/material";
import { useMemo, useState } from "react";

export default function GenericToggleGroup({
  activeChannels,
  group,
  setDeleteGroup,
  setActiveId,
  setActiveIds,
  deSelectIds,
  allowDelete,
}: {
  activeChannels: string[];
  group: any;
  setDeleteGroup: (id: string) => void;
  setActiveId: (id: string) => void;
  setActiveIds: (ids: string[]) => void;
  deSelectIds: (ids: string[]) => void;
  allowDelete?: boolean;
}) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const theme = useTheme();

  const mutatedGroup = useMemo(() => {
    const fleetGroupItems = group.fleetGroupItems.map((i) => ({
      ...i,
      active: activeChannels?.map((c) => c)?.includes(i?.feedId),
    }));
    const hasSome = activeChannels?.some((id) => group.fleetGroupItems?.map((i: any) => i.feedId).includes(id));

    return {
      ...group,
      hasSome,
      fleetGroupItems,
    };
  }, [group, activeChannels]);

  const selectAll = () => {
    const allIds = group?.fleetGroupItems?.map((i) => i.feedId);
    setActiveIds(allIds);
  };

  const deSelectAll = () => {
    const allIds = group?.fleetGroupItems?.map((i) => i.feedId);
    deSelectIds(allIds);
  };

  return (
    <Box sx={{ mb: 1, position: "relative" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Box sx={{ flexGrow: 1 }}>
          <Box
            className="basic-button"
            sx={{
              background: "transparent",
              "&:hover": { background: "transparent" },
              width: "100%",
              py: 0.5,
              px: 1,
            }}
            component="button"
            onClick={() => setIsOpen(!isOpen)}
          >
            <Box sx={{ display: "flex" }}>{isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</Box>
            <Box sx={{ fontWeight: "bold", textAlign: "left" }}>
              {mutatedGroup.name} ({mutatedGroup.fleetGroupItems?.length})
            </Box>
          </Box>
        </Box>
        {allowDelete && (
          <Box sx={{ display: "flex", mt: -0.5, alignItems: "center" }}>
            <Box
              component="button"
              sx={{ p: 0.5 }}
              className="basic-button danger"
              onClick={() => setDeleteGroup(mutatedGroup.id)}
            >
              <DeleteIcon sx={{ fontSize: "15px" }} />
            </Box>
          </Box>
        )}
      </Box>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Box sx={{ pl: 2 }}>
          {mutatedGroup?.fleetGroupItems?.length > 1 && (
            <Box
              component="button"
              className="basic-button"
              sx={{
                display: "flex",
                gap: 1,
                width: "100%",
                alignItems: "center",
                justifyContent: "start",
              }}
              key={`group-${group.id}`}
              onClick={() => (mutatedGroup.hasSome ? deSelectAll() : selectAll())}
            >
              {mutatedGroup.hasSome ? (
                <CheckBoxIcon sx={{ color: theme.palette.info.main }} />
              ) : (
                <CheckBoxOutlineBlankIcon sx={{ color: theme.palette.brand.other.gray.main }} />
              )}
              {mutatedGroup.hasSome ? "De-Select All" : "Select All"}
            </Box>
          )}

          {mutatedGroup?.fleetGroupItems?.length > 0 ? (
            mutatedGroup?.fleetGroupItems?.map((item) => (
              <Box
                component="button"
                className="basic-button"
                onClick={() => setActiveId(item.feedId)}
                sx={{
                  display: "flex",
                  gap: 1,
                  width: "100%",
                  alignItems: "center",
                }}
                key={`group-${group.id}-${item.id}`}
              >
                {item.active ? (
                  <CheckBoxIcon sx={{ color: theme.palette.info.main }} />
                ) : (
                  <CheckBoxOutlineBlankIcon sx={{ color: theme.palette.brand.other.gray.main }} />
                )}
                <Box>{item.feedName}</Box>
              </Box>
            ))
          ) : (
            <div>No Recipients</div>
          )}
        </Box>
      </Collapse>
    </Box>
  );
}
